import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import ExpandableChart from './ExpandableChart';

const RFModelChart = ({ data }) => {
  const formatData = data?.map(item => ({
    date: new Date(item.date).toLocaleDateString('en-US', { month: 'short', year: '2-digit' }),
    actual: parseInt(item.dh_cnt) || 0,
    predicted: parseFloat(item.Predicted) || 0
  })) || [];

  const images = [
    '501bcbbe-8a1c-4eff-ba8e-f1a8475c206c.png',
    '1f9bbd9f-9d6b-4de6-97f0-389352618901.png'
  ];

  return (
    <ExpandableChart 
      title="Random Forest Model: Actual vs Predicted Homeless Count"
      images={images}
    >
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={formatData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 12 }}
            />
            <YAxis
              tick={{ fontSize: 12 }}
              label={{
                value: 'Homeless Count',
                angle: -90,
                position: 'insideLeft',
                style: { textAnchor: 'middle' }
              }}
            />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="actual"
              stroke="#2563eb"
              name="Actual Count"
              dot={false}
            />
            <Line
              type="monotone"
              dataKey="predicted"
              stroke="#dc2626"
              name="Predicted Count"
              dot={false}
              strokeDasharray="5 5"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </ExpandableChart>
  );
};

export default RFModelChart;